import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "@/utils/cx";

export type HeadingLevel = "h1" | "h2" | "h3" | "h4";

export interface HeadingProps extends HTMLAttributes<HTMLHeadingElement> {
	/** Semantic heading level and visual style. */
	level?: HeadingLevel;
	/** Heading text content. */
	children: ReactNode;
}

const levelStyles: Record<HeadingLevel, string> = {
	h1: "text-display-sm font-display font-extrabold leading-[var(--text-display-sm--line-height,38px)]",
	h2: "text-display-xs font-display font-extrabold leading-[var(--text-display-xs--line-height,32px)]",
	h3: "text-xl font-display font-extrabold leading-[var(--text-xl--line-height,30px)]",
	h4: "text-lg font-display font-extrabold leading-[var(--text-lg--line-height,28px)]",
};

/**
 * Display heading for page and workspace titles (Figma Heading 552:4934).
 */
export function Heading({
	level = "h1",
	children,
	className,
	...props
}: HeadingProps) {
	const Tag = level;

	return (
		<Tag
			{...props}
			className={cx(
				"pt-(--spacing-xxs,2px) text-primary",
				levelStyles[level],
				className,
			)}
		>
			{children}
		</Tag>
	);
}
